import { SellerType } from '@kijiji/generated/graphql-types'

import { type VipQueryListing } from '@/types/listings'

export const isPaidListing = (listing: VipQueryListing): boolean => {
  if (!!listing.flags.isFromDealer || listing.posterInfo.sellerType === SellerType.Kmb) return true

  return false
}
